class FAQSection extends HTMLElement {
  constructor() {
    super();
    this.triggers = [];
    this.contents = [];
    this.activeId = null;
    this.onTriggerClick = this.onTriggerClick.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.setActive = this.setActive.bind(this);
  }

  connectedCallback() {
    this.triggers = Array.from(
      this.querySelectorAll(".section-faq__item--trigger")
    );
    this.contents = Array.from(
      this.querySelectorAll(".section-faq__item--content")
    );

    const activeTrigger = this.triggers.find((t) =>
      t.classList.contains("active")
    );
    const activeContent = this.contents.find((c) =>
      c.classList.contains("active")
    );
    this.activeId =
      (activeTrigger && activeTrigger.getAttribute("data-faq-trigger")) ||
      (activeContent && activeContent.getAttribute("data-faq-trigger")) ||
      null;

    this.triggers.forEach((trigger) => {
      trigger.addEventListener("click", this.onTriggerClick);
      trigger.addEventListener("keydown", this.onKeyDown);
    });
    // Initialize ARIA state
    this.triggers.forEach((trigger) => {
      const id = trigger.getAttribute("data-faq-trigger");
      const expanded = id === this.activeId;
      trigger.setAttribute("aria-expanded", expanded ? "true" : "false");
    });
    this.contents.forEach((content) => {
      const id = content.getAttribute("data-faq-trigger");
      const hidden = id !== this.activeId;
      content.setAttribute("aria-hidden", hidden ? "true" : "false");
    });
  }

  disconnectedCallback() {
    this.triggers.forEach((trigger) => {
      trigger.removeEventListener("click", this.onTriggerClick);
      trigger.removeEventListener("keydown", this.onKeyDown);
    });
  }

  onTriggerClick(event) {
    const trigger = event.currentTarget;
    const id = trigger.getAttribute("data-faq-trigger");
    if (!id || id === this.activeId) return;

    const nextContent = this.contents.find(
      (c) => c.getAttribute("data-faq-trigger") === id
    );
    const prevContent = this.contents.find(
      (c) => c.getAttribute("data-faq-trigger") === this.activeId
    );
    this.setActive(id, trigger, nextContent, prevContent);
  }

  onKeyDown(event) {
    const key = event.key;
    if (key === "Enter" || key === " " || key === "Spacebar") {
      event.preventDefault();
      this.onTriggerClick({ currentTarget: event.currentTarget });
    }
  }

  setActive(id, trigger, nextContent, prevContent) {
    // Toggle trigger active states
    this.triggers.forEach((t) => t.classList.toggle("active", t === trigger));

    // Hide previous content
    if (prevContent) {
      prevContent.classList.remove("active");
    }

    if (nextContent) {
      nextContent.classList.add("active");
      if (window.innerWidth < 768) {
        window.scrollTo({
          top: this.offsetTop,
          behavior: "smooth",
        });
      }
    }

    // Sync ARIA attributes
    this.triggers.forEach((t) =>
      t.setAttribute("aria-expanded", t === trigger ? "true" : "false")
    );
    this.contents.forEach((c) =>
      c.setAttribute("aria-hidden", c === nextContent ? "false" : "true")
    );

    this.activeId = id;
  }
}

customElements.define("faq-section", FAQSection);
